import { render, staticRenderFns } from "./skip-navigation-minimal.vue?vue&type=template&id=48eda77a&"
import script from "./skip-navigation-minimal.vue?vue&type=script&lang=js&"
export * from "./skip-navigation-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports